var map = {
	"./2chela_sidyat.svg": 8194,
	"./Chel_stoit.svg": 120,
	"./undraw.svg": 1326,
	"./undraw_artificial_intelligence_re_enpp.svg": 8955,
	"./undraw_design_team_re_gh2d.svg": 7858,
	"./undraw_investor_update_re_qnuu.svg": 2889,
	"./undraw_online_stats_0g94.svg": 2525,
	"./undraw_security_re_a2rk.svg": 4787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8675;